import { ExternalSource } from '../studio/PluginPromptList';
import { AgentInputFormItem } from './AgentInput';

export interface AiOnUIConnectData {
  apiKey?: string;
  userInputForm?: AgentInputFormItem[];
  openingStatement?: string;
  conversationStarters?: string[];
  useWorksAIConversationStarters?: boolean;
}

export interface PluginAPI {
  id: string;
  name: string;
  model: string | null;
  persona: string;
  description: string;
  profileUrl: string;
  isAvailable?: boolean;
  externalSource?: ExternalSource;
  aiOnUIConnectData?: AiOnUIConnectData;
  tags?: string[];
  conversationStarters?: string[];
  hidden?: boolean;
}
export interface Plugin {
  pluginInfo: PluginAPI;
  enabled: boolean;
}

export type Plugins = Record<string, PluginAPI>;

export interface PluginsState {
  plugins: Plugins;
  selectedPlugin: PluginAPI | null;
  inputValues: Record<string, string>;
  isInputFormVisible: boolean;
}

export const enum BuiltInPlugins {
  Wendy = 'Plugin:Wendy',
  AiSearch = 'Plugin:AiSearch',
  KtdsAssistant = 'Plugin:KtdsAssistant',
}
export interface WebSearch {
  label: string;
  source: WebSearchSource;
  icon: string;
  value: string;
  previewCount: number;
  isShowMenu: boolean;
  description: string;
}

export const enum WebSearchSource {
  WebSearch = 'WebSearch',
  Academic = 'Academic',
  YouTube = 'YouTube',
  News = 'News',
  Memory = 'Memory',
}

export const webSearchTool: Record<string, WebSearch> = {
  WebSearch: {
    label: 'Web',
    source: WebSearchSource.WebSearch,
    icon: 'websearch',
    value: 'WebSearch',
    previewCount: 2,
    isShowMenu: true,
    description: '실시간 웹 검색을 기반으로 보다 똑똑한 답변을 해 드려요.',
  },
  Academic: {
    label: 'Academic',
    source: WebSearchSource.Academic,
    icon: 'book',
    value: 'Academic',
    previewCount: 2,
    isShowMenu: true,
    description: '논문을 기반으로 신뢰성이 높은 답변을 해 드려요.',
  },
  YouTube: {
    label: 'YouTube',
    source: WebSearchSource.YouTube,
    icon: 'youtube',
    value: 'YouTube',
    previewCount: 3,
    isShowMenu: true,
    description: '유튜브에서 트렌디한 답변을 찾아요.',
  },
  Memory: {
    label: '이런 자료를 참고했어요',
    source: WebSearchSource.Memory,
    icon: 'info',
    value: 'Memory',
    previewCount: 2,
    isShowMenu: false,
    description: '',
  },
  News: {
    label: 'Web',
    source: WebSearchSource.News,
    icon: 'websearch',
    value: 'WebSearch',
    previewCount: 2,
    isShowMenu: false,
    description: '',
  },
};

export const initialState: PluginsState = {
  plugins: {},
  selectedPlugin: null,
  inputValues: {},
  isInputFormVisible: false,
};
